import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1db25b54")

_pushScopeId("data-v-1db25b54")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-1 font-12 font-bold padding-top-10" }
const _hoisted_3 = { class: "padding-top-10 text-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_paragraph_panel = _resolveComponent("paragraph-panel")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.preParagraphs, (p) => {
        return _withDirectives((_openBlock(), _createBlock(_component_paragraph_panel, {
          key: p.id,
          content: p.content,
          onReference: ($event: any) => (_ctx.reference(p))
        }, null, 8, ["content", "onReference"])), [
          [_vShow, _ctx.surroundingVisible]
        ])
      }), 128)),
      _createVNode(_component_paragraph_panel, {
        content: _ctx.paragraph.content,
        onReference: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reference(_ctx.paragraph)))
      }, null, 8, ["content"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.postParagraphs, (p) => {
        return _withDirectives((_openBlock(), _createBlock(_component_paragraph_panel, {
          key: p.id,
          content: p.content,
          onReference: ($event: any) => (_ctx.reference(p))
        }, null, 8, ["content", "onReference"])), [
          [_vShow, _ctx.surroundingVisible]
        ])
      }), 128)),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            target: "_blank",
            to: {name: 'BookDetail', params: { id: _ctx.paragraph.bookId }, query: {articleId: _ctx.paragraph.portionId, bigContentId: _ctx.paragraph.bigContentId}}
          }, {
            default: _withId(() => [
              _createVNode("div", null, "出自：" + _toDisplayString(`《${_ctx.paragraph.bookName}》  ${_ctx.paragraph.author || ''}`), 1),
              _createVNode("div", null, "章节：" + _toDisplayString(`${_ctx.paragraph.parentTitle ? _ctx.paragraph.parentTitle + '-' : ''}${_ctx.paragraph.title}`), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_tooltip, {
            content: "展开",
            "show-after": 500,
            placement: "bottom",
            effect: "light"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_button, {
                size: "small",
                icon: "el-icon-d-caret",
                circle: "",
                onClick: _ctx.showSurrounding
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          (_ctx.surroundingVisible)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "收缩",
                "show-after": 500,
                placement: "bottom",
                effect: "light"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: "el-icon-aim",
                    circle: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.surroundingVisible = false))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_tooltip, {
            content: "全部引用",
            "show-after": 500,
            placement: "bottom",
            effect: "light"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_button, {
                size: "small",
                icon: "el-icon-d-arrow-right",
                circle: "",
                onClick: _ctx.referenceAll
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
})